; (function (jQuery) {

	"use strict";

	function Accordion(section) {
		var fn = {
			init: function () {
				jQuery(section).find('.accordion__trigger').each(function () {
					jQuery(this).on('click', fn.toggleAccordion);
				});

				jQuery(section).find('.accordion__trigger').on('keydown', fn.eventHandler);
			},
			eventHandler: function (e) {
				const triggers = jQuery(section).find('.accordion__trigger');
				const currentIndex = triggers.index(this);

				switch(e.key) {
					case 'ArrowDown':
					case 'ArrowRight':
						e.preventDefault();
						const nextIndex = (currentIndex + 1) % triggers.length;
						triggers.eq(nextIndex).trigger('focus');
						break;
					case 'ArrowUp':
					case 'ArrowLeft':
						e.preventDefault();
						const prevIndex = currentIndex === 0 ? triggers.length - 1 : currentIndex - 1;
						triggers.eq(prevIndex).trigger('focus');
						break;
					case 'Home':
						e.preventDefault();
						triggers.first().trigger('focus');
						break;
					case 'End':
						e.preventDefault();
						triggers.last().trigger('focus');
						break;
				}
			},

			toggleAccordion: function (e) {
				e.preventDefault();

				const trigger = jQuery(e.target);
				const content = trigger.closest('div').find('.accordion__content');
				const isExpanded = trigger.attr('aria-expanded') === 'true';

				trigger.attr('aria-expanded', !isExpanded);

				if (isExpanded) {
					content.attr('hidden', '');
				} else {
					content.removeAttr('hidden');

					const triggersAll = jQuery(section)
						.find('.accordion__trigger')
						.not(trigger);

					// Close any other open accordions
					triggersAll
						.each(function (e) {
							jQuery(this).attr('aria-expanded', false);
							const content = jQuery(this).closest('div').find('.accordion__content');
							content.attr('hidden', '');
						});

				}
			}
		}

		jQuery(fn.init);
	}

	jQuery('.accordions').each(function() {
		new Accordion(this);
	});
})(jQuery);
